<template>
  <div class="display-flex width-percent-100">
    <div class="width-260">
      <div class="bc-white br-4 padding-20">
        <el-button
          icon="el-icon-plus"
          type="primary"
          class="width-percent-100 mb-18"
          size="small"
          @click="addDept(2)">添加部门</el-button>
        <el-tree
          :expand-on-click-node="false"
          default-expand-all
          :data="deptData"
          :props="defaultProps"
          @node-click="handleNodeClick"></el-tree>
      </div>
    </div>
    <div class="flex-4 bc-white br-4 ml-20" style="overflow: hidden">
      <header class="padding-20">
        <b class="fs-18">{{ checkedDept.name }}</b>
        <i @click="editDept" class="cursor-pointer ml-10 fs-18 el-icon-edit-outline color-primary"></i>
        <i @click="delDept" class="cursor-pointer ml-10 fs-18 el-icon-delete color-danger"></i>
      </header>
      <el-divider></el-divider>
      <div class="padding-20">
        <div class="display-flex jc-space-between">
            <el-form :inline="true" size="small" v-model="searchForm">
              <el-form-item label="">
                <el-input v-model="searchForm.fuzzy" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" icon="el-icon-search" @click="getTableData">查询</el-button>
                <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
            <div>
              <el-button size="small" type="primary" icon="el-icon-plus" @click="addUser">添加员工</el-button>
              <el-button size="small" type="danger" icon="el-icon-delete" @click="delRow(selection)">批量删除</el-button>
            </div>
        </div>
        <b>共{{ total }}条人员信息</b>
        <el-table
          class="mt-20"
          border
          :data="tableData"
          @selection-change="(val) => {selection = val}">
          <el-table-column
            fixed
            align="center"
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            show-overflow-tooltip
            prop="name"
            width="120"
            label="姓名">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            show-overflow-tooltip
            label="性别">
            <template slot-scope="scope">
              {{ scope.row.sex ? '女' : '男' }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="mobile"
            label="手机号">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="deptName"
            label="部门">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="position"
            label="岗位">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="roleName"
            label="角色">
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="200px"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="resetPassword(scope.row)" type="text" class="color-primary">重置密码</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button @click="editRow(scope.row)" type="text" class="color-primary">编辑</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button @click="delRow([scope.row])" type="text" class="color-danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="display-flex fd-row-reverse mt-20">
          <!-- 表格数据的分页的功能 -->
          <el-pagination
            hide-on-single-page
            @current-change="(val) => {searchForm.page = val}"
            :current-page="searchForm.page"
            :page-size="searchForm.limit"
            background
            layout="total, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-drawer
      v-if="deptDrawer.show"
      append-to-body
      size="auto"
      :title="deptDrawer.title"
      :visible.sync="deptDrawer.show">
      <el-form :model="deptDrawer.form" ref="deptDrawerForm" label-width="100px" class="padding-20 pl-12">
        <el-form-item label="部门名称：" prop="name" :rules="{required: true, message: '请输入部门名称', trigger: 'blur'}">
          <el-input v-model="deptDrawer.form.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门主管：">
          <personnel-selection
            class="width-percent-100"
            :default-checked-keys="[deptDrawer.form.managerId]"
            placeholder="请选择部门主管"
            :multiple="false"
            @change="(data, ids) => {deptDrawer.form.managerId = ids[0]}"></personnel-selection>
        </el-form-item>
        <el-form-item label="显示排序：">
          <el-input-number v-model="deptDrawer.form.sort" controls-position="right" :min="1" class="width-percent-100"/>
        </el-form-item>
        <el-form-item label="上级部门：" v-if="!deptDrawer.title.includes('顶级')">
          <el-cascader
            class="width-percent-100"
            v-model="deptDrawer.form.parentId"
            :options="deptData"
            :props="{
              emitPath: false,
              checkStrictly: true,
              label: 'title',
              value: 'id'
            }"
            clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" type="primary" @click="submitDeptForm('deptDrawerForm')">确认</el-button>
          <el-button @click="deptDrawer.show = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      append-to-body
      size="auto"
      :title="userDrawer.title"
      :visible.sync="userDrawer.show">
      <el-form
        :model="userDrawer.form"
        ref="deptUserForm"
        label-width="100px"
        style="width: 400px;"
        class="padding-20">
        <el-form-item label="姓名：" prop="name" :rules="{required: true, message: '请输入姓名', trigger: 'blur'}">
          <el-input v-model="userDrawer.form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex"  :rules="{required: true, message: '请选择性别', trigger: 'blur'}">
          <el-radio-group v-model="userDrawer.form.sex">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile" :rules="{required: true, message: '请输入手机号', trigger: 'blur'}">
          <el-input v-model="userDrawer.form.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
<!--        <el-form-item label="部门：" prop="deptId" :rules="{required: true, message: '请选择部门', trigger: 'blur'}">-->
<!--          <el-cascader-->
<!--            filterable-->
<!--            class="width-percent-100"-->
<!--            v-model="userDrawer.form.deptId"-->
<!--            :options="deptData"-->
<!--            :props="{-->
<!--              emitPath: false,-->
<!--              checkStrictly: true,-->
<!--              label: 'title',-->
<!--              value: 'id'-->
<!--            }"-->
<!--            clearable></el-cascader>-->
<!--        </el-form-item>-->
        <el-form-item label="角色：" prop="roleId" :rules="{required: true, message: '请选择角色', trigger: 'blur'}">
          <el-select class="width-percent-100" filterable v-model="userDrawer.form.roleId" placeholder="请选择角色">
            <el-option
              v-for="item in roleOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位：" prop="position" :rules="{required: true, message: '请输入岗位', trigger: 'blur'}">
          <el-input v-model="userDrawer.form.position" placeholder="请输入岗位"></el-input>
        </el-form-item>
        <el-form-item label="显示排序：" required>
          <el-input-number class="width-percent-100" v-model="userDrawer.form.sort" controls-position="right" :min="1"/>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" type="primary" @click="submitUserForm('deptUserForm')">确认</el-button>
          <el-button @click="userDrawer.show = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import _ from 'lodash';
import PersonnelSelection from '@/components/PersonnelSelection';

export default {
  name: 'Organization', // 组织机构
  components: { PersonnelSelection },
  data () {
    return {
      submitLoading: false,
      userId: null, // 编辑员工用，用户id
      roleOption: [],
      checkedDept: {}, // 当前选择的部门
      deptDrawer: {
        show: false,
        title: '',
        form: {
          name: '',
          managerId: '',
          parentId: null,
          sort: 1
        }
      },
      userDrawer: {
        show: false,
        title: '',
        form: {
          deptId: '',
          email: '',
          mobile: '',
          sort: 1,
          sex: 0,
          name: '',
          position: '',
          roleId: ''
        }
      },
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      deptData: [],
      searchForm: {
        fuzzy: '',
        page: 1,
        limit: 10
      },
      selection: [],
      tableData: [],
      total: 0
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.page !== 1 && newVal.page === oldVal.page) {
          this.searchForm.page = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    }
  },
  methods: {
    resetSearch () {
      this.searchForm.fuzzy = ''
      this.searchForm.page = 1
      this.getTableData()
    },
    /**
     * 添加员工
     */
    addUser () {
      this.userId = null
      this.userDrawer.title = '添加员工'
      this.userDrawer.form = {
        deptId: this.checkedDept.id,
        email: '',
        mobile: '',
        sort: 1,
        sex: 0,
        name: '',
        position: '',
        roleId: ''
      }
      this.userDrawer.show = true
    },
    /**
     * 编辑员工
     * @param row
     */
    editRow (row) {
      this.userId = row.id
      this.userDrawer.title = '编辑员工'
      this.$api.organization.personnelDetail({ id: row.id, tenantId: this.tenantId }).then(res => {
        this.userDrawer.form = {
          deptId: res.deptId,
          email: res.email,
          mobile: res.mobile,
          sort: res.sort,
          sex: res.sex,
          name: res.name,
          position: res.position,
          roleId: res.roleId
        }
        this.userDrawer.show = true
      })
    },
    /**
     * 删除
     * @param data
     */
    delRow (data) {
      const ids = data.map(item => item.id)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.organization.deletePersonnel(ids).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {
      });
    },
    /**
     * 重置密码
     * @param row
     */
    resetPassword (row) {
      this.$confirm('此操作将重置密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.organization.resetPassword(row.id, this.tenantId).then(res => {
          this.$message.success('重置成功')
        })
      }).catch(() => {
      });
    },
    /**
     * 添加部门
     * @param type
     */
    addDept (type) {
      this.deptDrawer.title = type === 1 ? '添加顶级部门' : '添加部门'
      this.deptDrawer.form = {
        name: '',
        managerId: '',
        parentId: null,
        sort: 1
      }
      this.deptDrawer.show = true
    },
    /**
     * 修改部门信息
     */
    editDept () {
      this.deptDrawer.title = '修改部门信息'
      this.deptDrawer.form = {
        managerId: this.checkedDept.managerId,
        name: this.checkedDept.name,
        parentId: this.checkedDept.parentId === '0' ? null : this.checkedDept.parentId,
        sort: this.checkedDept.sort
      }
      this.deptDrawer.show = true
    },
    /**
     * 删除部门
     */
    delDept () {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.organization.deleteDepartment({ ids: [this.checkedDept.id], tenantId: this.tenantId }).then(res => {
          this.$message.success('删除成功')
          this.getDeptTree().then(res => {
            this.getDeptDetail(res[0].id).then(() => {
              this.searchForm.page = 1
              this.getTableData()
            })
          })
        })
      }).catch(() => {
      });
    },
    /**
     * 提交部门表单
     * @param formName
     */
    submitDeptForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const data = {
            name: this.deptDrawer.form.name,
            parentId: this.deptDrawer.form.parentId,
            sort: this.deptDrawer.form.sort,
            tenantId: this.tenantId
          }
          if (this.deptDrawer.title.includes('修改')) {
            data.id = this.checkedDept.id
            this.$api.organization.updateDepartment(data).then(res => {
              this.$message.success('编辑成功')
              this.deptDrawer.show = false
              this.getDeptDetail(data.id)
              this.getDeptTree()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          } else {
            this.$api.organization.addDepartment(data).then(res => {
              this.$message.success('添加成功')
              this.deptDrawer.show = false
              this.getDeptTree()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          }
        }
      });
    },
    /**
     * 提交人员表单
     * @param formName
     */
    submitUserForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const data = Object.assign(this.userDrawer.form)
          data.avatarUrl = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
          if (this.userId) {
            data.id = this.userId
            this.$api.organization.updatePersonnel(data).then(res => {
              this.$message.success('编辑成功')
              this.userDrawer.show = false
              this.getTableData()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          } else {
            this.$api.organization.addPersonnel(data).then(res => {
              this.$message.success('添加成功')
              this.userDrawer.show = false
              this.searchForm.page = 1
              this.getTableData()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          }
        }
      });
    },
    /**
     * 选择部门
     * @param data
     */
    handleNodeClick (data) {
      this.getDeptDetail(data.id).then(() => {
        this.searchForm.page = 1
        this.getTableData()
      })
    },
    /**
     * 获取部门树
     * @returns {Promise<unknown>}
     */
    getDeptTree () {
      return new Promise((resolve, reject) => {
        this.$api.common.departmentTree().then(res => {
          this.deptData = res
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * 获取部门详情
     * @param id
     * @returns {Promise<unknown>}
     */
    getDeptDetail (id) {
      return new Promise((resolve, reject) => {
        this.$api.organization.departmentDetail({ id }).then(res => {
          this.checkedDept = res
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getTableData: _.debounce(function () {
      const data = {
        deptId: this.checkedDept.id,
        fuzzy: this.searchForm.fuzzy,
        pageNum: this.searchForm.page,
        pageSize: this.searchForm.limit
      }
      this.$api.organization.personnelList(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)
  },
  created () {

  },
  mounted () {
    const data = {
      pageNum: 1,
      pageSize: 99,
      fuzzy: ''
    }
    this.$api.role.getRoleList(data).then(res => {
      this.roleOption = res.list
    })
    this.getDeptTree().then(res => {
      if (res.length) {
        this.getDeptDetail(res[0].id).then(() => {
          this.getTableData()
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.change-tenant {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #328FFF;
}
</style>
